import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";

export interface SectionHeaderProps {
  title: string;
  description?: string;
  action?: { label: string; href: string };
  className?: string;
  onClickPrev?: () => void;
  onClickNext?: () => void;
}

export function SectionHeader({
  title,
  action,
  className,
  onClickPrev,
  onClickNext,
}: SectionHeaderProps) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "mb-10 flex min-h-[55px] w-full items-center gap-10",
        className,
      )}
    >
      <h2 className="shrink-0 text-balance font-sans text-[28px] font-bold leading-[33px] text-text-primary">
        {title}
      </h2>
      <div className="h-px flex-1 bg-[#eaebec]" />
      <div className="flex shrink-0 items-center gap-5">
        {(onClickPrev || onClickNext) && (
          <>
            <button
              type="button"
              onClick={onClickPrev}
              className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-[#E2E5E8] bg-white transition-shadow hover:shadow-[var(--shadow-card)]"
              aria-label={t("common.previous")}
            >
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
                <path d="M10.082 1.23633C10.2813 1.43555 10.3809 1.66992 10.3809 1.93946C10.3809 2.20899 10.2813 2.44336 10.082 2.64258L4.79101 7.8457H18.379C18.6602 7.8457 18.8946 7.94531 19.0821 8.14453C19.2813 8.33203 19.3809 8.56055 19.3809 8.83008C19.3809 9.09961 19.2813 9.33399 19.0821 9.5332C18.8946 9.7207 18.6602 9.81446 18.379 9.81446H4.79101L10.082 15.0176C10.2813 15.2168 10.3809 15.4512 10.3809 15.7207C10.3809 15.9903 10.2813 16.2246 10.082 16.4239C9.89454 16.6113 9.66015 16.7051 9.3789 16.7051C9.10937 16.7051 8.875 16.6113 8.67578 16.4239L1.67969 9.5332C1.48047 9.33399 1.38086 9.09961 1.38086 8.83008C1.38086 8.56055 1.48047 8.32617 1.67969 8.12696L8.67578 1.23633C8.875 1.04883 9.10937 0.955078 9.3789 0.955078C9.66015 0.955078 9.89454 1.04883 10.082 1.23633Z" fill="#040033" />
              </svg>
            </button>
            <button
              type="button"
              onClick={onClickNext}
              className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-[#E2E5E8] bg-white transition-shadow hover:shadow-[var(--shadow-card)]"
              aria-label={t("common.next")}
            >
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
                <path d="M10.6797 1.23633C10.8672 1.04883 11.0957 0.955078 11.3653 0.955078C11.6465 0.955078 11.8868 1.04883 12.086 1.23633L19.0821 8.12696C19.2813 8.32617 19.3809 8.56055 19.3809 8.83008C19.3809 9.09961 19.2813 9.33399 19.0821 9.5332L12.086 16.4239C11.8868 16.6113 11.6465 16.7051 11.3653 16.7051C11.0957 16.7051 10.8672 16.6113 10.6797 16.4239C10.4805 16.2246 10.3809 15.9903 10.3809 15.7207C10.3809 15.4512 10.4805 15.2168 10.6797 15.0176L15.9707 9.81446H2.38281C2.10156 9.81446 1.86132 9.7207 1.66211 9.5332C1.47461 9.33399 1.38086 9.09961 1.38086 8.83008C1.38086 8.56055 1.47461 8.33203 1.66211 8.14453C1.86132 7.94531 2.10156 7.8457 2.38281 7.8457H15.9707L10.6797 2.64258C10.4805 2.44336 10.3809 2.20899 10.3809 1.93946C10.3809 1.66992 10.4805 1.43555 10.6797 1.23633Z" fill="#040033" />
              </svg>
            </button>
          </>
        )}
        {action && (
          <a
            href={action.href}
            className="flex min-h-[50px] items-center justify-center gap-2.5 rounded-[25px] bg-primary navy-depth px-[30px] py-[15px] font-sans text-[15px] font-bold leading-5 text-white"
          >
            {action.label}
            <img src="/images/arrow-right.svg" alt="" aria-hidden="true" width={20} height={18} />
          </a>
        )}
      </div>
    </div>
  );
}
